import Text from 'components/base/Text'
import styled from 'styled-components'
import css from '@styled-system/css'
import Card from 'components/generic/Card'
import { FeatureProps } from './ProfileCard'

export const CardContainer = styled(Card)<FeatureProps>`
  display: flex;
  flex-wrap: ${({ features }) => (features?.sisterProfile ? 'wrap' : 'no-wrap')};
  word-break: break-word;
`

export const SiteBanner = styled(Text)<{ badge: string }>`
  align-items: center;
  display: flex;
  width: 100%;
  height: 30px;
  position: relative;
  background-image: ${({ badge }) => (badge ? `url(${badge})` : 'none')};
  background-repeat: no-repeat;
  background-size: 18px;
  background-position: 0 center;
  padding-left: ${({ badge }) => (badge ? `25px` : '0')};

  &:before,
  &:after {
    position: absolute;
    top: 0;
    content: '';
    height: 100%;

    ${css({
      backgroundColor: 'gray.0',
      paddingLeft: 4,
    })}
  }
  &:before {
    ${css({
      left: -4,
    })}
  }
  &:after {
    ${css({
      right: -4,
    })}
  }

  ${css({
    backgroundColor: 'gray.0',
    marginTop: -4,
    marginBottom: 4,
  })}
`
